import { BaseService } from './base/BaseService'

interface OrgSettingsResponse {
  personalizeWithIdentity: boolean
  consentEnforcementEnabled: boolean
  pageViewCaptureEnabled: boolean
}

// A PUT carrying one key leaves the others alone, so each setting owns its own pair here.
class OrgSettingsService extends BaseService {
  protected readonly baseURL = '/organization_settings'

  async getPersonalizeIdentity(): Promise<boolean> {
    const response = await this.get<OrgSettingsResponse>('')
    return response.personalizeWithIdentity
  }

  async updatePersonalizeIdentity(enabled: boolean): Promise<boolean> {
    const response = await this.put<OrgSettingsResponse>('', {
      organizationSettings: { personalizeWithIdentity: enabled },
    })
    return response.personalizeWithIdentity
  }

  async getConsentEnforcement(): Promise<boolean> {
    const response = await this.get<OrgSettingsResponse>('')
    return response.consentEnforcementEnabled
  }

  async updateConsentEnforcement(enabled: boolean): Promise<boolean> {
    const response = await this.put<OrgSettingsResponse>('', {
      organizationSettings: { consentEnforcementEnabled: enabled },
    })
    return response.consentEnforcementEnabled
  }

  async getPageViewCapture(): Promise<boolean> {
    const response = await this.get<OrgSettingsResponse>('')

    return response.pageViewCaptureEnabled
  }

  async updatePageViewCapture(enabled: boolean): Promise<boolean> {
    const response = await this.put<OrgSettingsResponse>('', {
      organizationSettings: { pageViewCaptureEnabled: enabled },
    })

    return response.pageViewCaptureEnabled
  }
}

export const orgSettingsService = new OrgSettingsService()
